// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container__Y_cLq","mainList":"index_mainList__8fXTG","title":"index_title__4ir1P","desc":"index_desc__AMxGp"};